import {
  fetchFileFromRemote,
  getDuration,
  getReminderTimeArray,
  getRemindTimeFromEventData,
  calculateDate,
  getFrequencyOptions,
  defaultFrequencyOption,
} from '../../common/helpers'

export const mapFormDataToEventDto = async (formValues, advancedTicketingEnabled) => {
  const image = formValues.image.url
    ? await fetchFileFromRemote(formValues.image.url)
    : formValues.image

  const formData = {
    event: true,
    // Event details
    buildingId: formValues.building.id,
    ...(formValues.type ? { type: formValues.type.text } : {}),
    name: formValues.name,
    ...(formValues.organizer ? { trainerId: formValues.organizer.id } : {}),
    description: formValues.description,
    image: image,
    files: formValues.files,
    // Date/Time
    place: formValues.place,
    date: calculateDate(formValues.timeStart, formValues.building.timezone),
    duration: getDuration(formValues.timeStart, formValues.timeEnd),
    schedulerType:
      formValues.frequency && formValues.frequency !== 'none' ? formValues.frequency : null,

    // Tickets
    capacity: formValues.capacity,
    guestsAmount: formValues.guestsAmount,
    collectGuestsInfo: formValues.collectGuestsInfo,
    tickets: formValues.tickets.map((ticket) => ({
      ...(ticket.id ? { id: ticket.id } : {}),
      name: ticket.name,
      description: ticket.description,
      price: parseInt(ticket.price),
      ...(advancedTicketingEnabled && { inactive: ticket.inactive }),
    })),

    // Advanced - attendees
    householdMembersAllowed: formValues.householdMembersAllowed,

    // Advanced - rsvp
    collectRSVP: formValues.collectRSVP,
    signUpLink: formValues.collectRSVP ? formValues.signUpLink : '',
    hideAttendees: formValues.hideAttendees,

    // Advanced  - communication
    remindRsvpBeforeHours: formValues.remindRsvp
      ? getReminderTimeArray(formValues.remindRsvpValues)
      : [],
    remindAllBeforeHours: formValues.remindAll
      ? getReminderTimeArray(formValues.remindAllValues)
      : [],
    createEventSurvey: formValues.askForPostEventReview,
    socialLinkService: formValues.socialLinkService || null,
    ...(formValues.positiveReview && formValues.replyTo ? { replyTo: formValues.replyTo } : {}),
    isPrivate: formValues.isPrivate,
  }

  return formData
}

export const mapEventDtoToFormData = ({
  eventData,
  buildingOptions,
  eventTypeOptions,
  trainerOptions,
}) => {
  const formData = {
    building: buildingOptions.find((option) => option.id === eventData.buildingId.id),
    type: eventTypeOptions.find((option) => option.id === eventData.type.id),
    name: eventData.name,
    organizer: trainerOptions.find((option) => option.id === eventData.trainerId?.id),
    description: eventData.description,
    image: eventData.image,
    files: eventData.files || [],
    // Date/Time
    place: eventData.place,
    timeStart: eventData.start,
    timeEnd: eventData.end,
    frequency:
      getFrequencyOptions().find((option) => option.value === eventData.schedulerType)?.value ||
      defaultFrequencyOption,
    // Tickets
    capacity: eventData.capacity,
    guestsAmount: eventData.guestsAmount,
    collectGuestsInfo: eventData.collectGuestsInfo,
    tickets: eventData.tickets,
    // Advanced - attendees
    householdMembersAllowed: eventData.householdMembersAllowed,
    // Advanced - rsvp
    collectRSVP: !!eventData.signUpLink,
    signUpLink: eventData.signUpLink,
    hideAttendees: eventData.hideAttendees,
    // Advanced - Communication
    automatedRemindersToggle:
      !!eventData.remindAllBeforeHours.length || !!eventData.remindRsvpBeforeHours.length,
    remindRsvp: !!eventData.remindRsvpBeforeHours.length,
    remindRsvpValues: eventData.remindRsvpBeforeHours
      ? getRemindTimeFromEventData(eventData.remindRsvpBeforeHours)
      : [''],
    remindAll: !!eventData.remindAllBeforeHours.length,
    remindAllValues: eventData.remindAllBeforeHours
      ? getRemindTimeFromEventData(eventData.remindAllBeforeHours)
      : [''],
    askForPostEventReview: !!eventData.createEventSurvey,
    positiveReview: !!eventData.socialLinkService,
    socialLinkService: eventData.socialLinkService || '',
    replyTo: eventData.replyTo || '',
    isPrivate: !!eventData.isPrivate,
  }

  return formData
}
